import { render, staticRenderFns } from "./BasicMeasure.vue?vue&type=template&id=4c2d27c3&scoped=true&"
import script from "./BasicMeasure.vue?vue&type=script&lang=js&"
export * from "./BasicMeasure.vue?vue&type=script&lang=js&"
import style0 from "./BasicMeasure.vue?vue&type=style&index=0&id=4c2d27c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2d27c3",
  null
  
)

export default component.exports